import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=2e0582c8&scoped=true"
import script from "./Move.vue?vue&type=script&lang=js"
export * from "./Move.vue?vue&type=script&lang=js"
import style0 from "./Move.vue?vue&type=style&index=0&id=2e0582c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0582c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0582c8')) {
      api.createRecord('2e0582c8', component.options)
    } else {
      api.reload('2e0582c8', component.options)
    }
    module.hot.accept("./Move.vue?vue&type=template&id=2e0582c8&scoped=true", function () {
      api.rerender('2e0582c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Move.vue"
export default component.exports